import React from 'react'
import { createDivAtom } from 'shared/atoms/factory'

import Projects from './components/Projects/Projects.container'
import Organisations from './components/Organisations/Organisations.container'
import Help from './components/Help/Help.component'

import styles from './TopBar.module.scss'

const RightSideWrapper = createDivAtom()

const TopBar = () => (
  <main className={styles.wrapper}>
    <Projects />

    <RightSideWrapper className={styles.rightSideWrapper}>
      <Organisations />
      <Help />
    </RightSideWrapper>
  </main>
)

export default TopBar
